import { render, staticRenderFns } from "./ReviseResveration.vue?vue&type=template&id=35c99de5"
import script from "./ReviseResveration.vue?vue&type=script&lang=js"
export * from "./ReviseResveration.vue?vue&type=script&lang=js"
import style0 from "./ReviseResveration.vue?vue&type=style&index=0&id=35c99de5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports